<template>
    <svg
        version="1.1"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="-22 0 425 425.6"
        style="enable-background:new -22 0 425 425.6; ">
        <path d="m299 14.101562 67.300781 67.199219h-37.300781c-16.546875-.050781-29.953125-13.453125-30-30zm-65.199219
            411.5h-203.5c-16.550781-.050781-29.953125-13.453124-30-30v-294.703124c.046875-16.546876 13.449219-29.949219
            30-30h132.300781v51.300781c.007813 27.609375 22.386719 49.992187 50 50h51.296876v223.402343c-.09375 16.566407-13.53125 29.957032-30.097657
            30zm16.097657-273.402343h-37.296876c-16.550781-.046875-29.953124-13.449219-30-30v-37.199219zm100.402343
            202.5h-66.5v-192.699219c-.019531-2.652344-1.058593-5.191406-2.902343-7.101562l-101-100.898438-.097657-.101562c-1.886719-1.945313-4.492187-3.027344-7.199219-3h-55.800781v-20.898438c.046875-16.546875 13.449219-29.953125 30-30h132.300781v51.300781c.007813
            27.609375 22.386719 49.988281 50 50h51.199219v223.398438c-.050781 16.550781-13.453125 29.953125-30 30zm0 0">
        </path>
    </svg>
</template>

<script>
    export default {}
</script>

<style scoped>

</style>
